import "./TabelaExtratoAdmin.css";
import { FaRegEdit } from "react-icons/fa";
import { useState } from "react";
import Modal from "./Modal";
import FormularioComissao from "../../Formulario/FormularioComissao";

const TabelaExtratoAdmin = (props) => {
  const itens = props.itensLista || [];
  const licenciados = props.licenciados || [];

  const [open, setOpen] = useState(false);
  const [editId, setEditId] = useState(null);

  const abrirEdicao = (id) => {
    setEditId(id);
    setOpen(true);
  };

  const fechar = () => {
    setOpen(false);
    setEditId(null);
  };

  function formatCurrencyBRL(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return "R$ 0,00";

    return n.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function formatarDataBRL(data) {
    if (!data) return "-";
    const d = new Date(data);
    if (isNaN(d.getTime())) return "-";

    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();

    return `${dia}/${mes}/${ano}`;
  }

  function renderizarStatus(status) {
    switch (status) {
      case "CONFIRMED":
        return <span className="status-pill status-credito">Confirmado</span>;
      case "PENDING":
        return (
          <span className="status-pill status-analise">
            Aguardando confirmação
          </span>
        );
      case "WITHDRAW_REQUESTED":
        return (
          <span className="status-pill status-saque-solicitado">
            Saque solicitado
          </span>
        );
      default:
        return <span className="status-pill">-</span>;
    }
  }

  return (
    <section className="table-card">
      <div className="table-title">{props.children}</div>

      <div className="table-tr">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Licenciado</th>
              <th>Nº compra</th>
              <th>Cliente</th>
              <th>Valor compra</th>
              <th>Valor comissão</th>
              <th>Tipo</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>

          <tbody id="extratoTableBody">
            {itens.length === 0 && (
              <tr>
                <td colSpan={8} style={{ textAlign: "center" }}>
                  Nenhum lançamento encontrado
                </td>
              </tr>
            )}

            {itens.map((item) => {
              const isSaque = item.origin === "WITHDRAW";

              const purchaseAmount = Number(item.purchase_amount) || 0;
              const commissionPercent = Number(item.commission_percent) || 0;

              const commissionValue =
                (purchaseAmount * commissionPercent) / 100;

              const commissionFinal = isSaque
                ? -purchaseAmount
                : commissionValue;

              return (
                <tr key={item.id}>
                  <td>{formatarDataBRL(item.created_at)}</td>

                  {/* ✅ Nome do licenciado */}
                  <td>
                    {item.user_name ||
                      item.licenciado_nome ||
                      item.licenciado ||
                      `#${item.user_id}`}
                  </td>

                  <td>{item.order_number || "-"}</td>
                  <td>{item.client_name || "-"}</td>

                  <td>{formatCurrencyBRL(purchaseAmount)}</td>
                  <td>{formatCurrencyBRL(commissionFinal)}</td>

                  <td
                    className={
                      isSaque ? "tipo-debito" : "tipo-credito"
                    }
                  >
                    {isSaque ? "Débito" : "Crédito"}
                  </td>

                  <td>{renderizarStatus(item.status)}</td>

                  <td className="td-actions">
                    <button
                      type="button"
                      className="icon-btn"
                      title="Editar lançamento"
                      onClick={() => abrirEdicao(item.id)}
                    >
                      <FaRegEdit />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <Modal open={open} title="Editar lançamento" onClose={fechar}>
        <FormularioComissao
          licenciados={licenciados}
          modo="edit"
          editId={editId}
          onClose={fechar}
          lancamentoAtualizado={(itemAtualizado) => {
            props.onItemAtualizado?.(itemAtualizado);
            fechar();
          }}
        />
      </Modal>
    </section>
  );
};

export default TabelaExtratoAdmin;
